import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
//import './index.css';
import './assets/css/style.css';
import App from './App';
//import reportWebVitals from './reportWebVitals';

const baseUrl = document.getElementById('baseRelativePath').getAttribute('href');
const rootElement = document.getElementById('root');

ReactDOM.render(
    <BrowserRouter basename={baseUrl}>
            <App />
    </BrowserRouter>,
  rootElement);


if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
        navigator.serviceWorker.register(`${baseUrl}service-worker.js`, { scope: baseUrl }).then(registration => {
            console.log('SW registered');
        }).catch(registrationError => {
            console.log('SW registration failed: ', registrationError);
        });
    });
}
